export default __webpack_public_path__ + "static/media/play-run-case.b869ce3b.svg";